class MFRProductStickyBar {
	constructor( i, e, options ) {
		this.$index = i
		this.$element = $( e )

		this.selectors = {
			firstSection : "main .shopify-section:first-child",
			quantitySelectorInput: ".quantity-selector__input",
			quantitySelectorContainer: ".quantity-selector__count",
			customQuantitySelector: ".mfr-product__top .custom-quantity-selector",
			stickyBarForm: ".product-sticky-bar__form",
			stickyBarCurrentPrice: "input[name='properties[_current_price]']",
			stickyBarCounter: "#sticky-counter",
			stickyBarPriceCounter: "#sticky-price",
			stickyBarQuantitySelector: ".quantity-selector",
			stickyBarAddOnsQuantitySelector: ".addons-quantity-selector__input",
			stickyBarAddOnsTotalSelector: ".addons-price-selector__input-total",
			stickyBarAddOnsPriceSelector: ".addons-price-selector__input",
		}

		this.options = options
		this.addOnComponent = $(this.options.addOnComponent)

		this.states = {
			currentProductQty: 1,
			currentProductPrice: 0,
			currentAddOnsProductQty: 0,
			currentTotalPrice: 0
		}

		this.init()
	}

	init() {
		this.$quantitySelector = this.$element.find(this.selectors.stickyBarQuantitySelector)
		this.$quantitySelectorInput = $(this.selectors.quantitySelectorInput);
		this.$quantitySelectorContainer = $(this.selectors.quantitySelectorContainer);
		this.$customQuantitySelector = $(this.selectors.customQuantitySelector);

		this.$stickyBarForm = this.$element.find(this.selectors.stickyBarForm).find('form')
		this.$stickyBarCurrentPrice = this.$element.find(this.selectors.stickyBarCurrentPrice)
		this.$stickyBarCounter = this.$element.find(this.selectors.stickyBarCounter)
		this.$stickyBarPriceCounter = this.$element.find(this.selectors.stickyBarPriceCounter)
		this.$addOnsQuantitySelector = this.addOnComponent.find(this.selectors.stickyBarAddOnsQuantitySelector)
		this.$addOnsPriceSelector = this.addOnComponent.find(this.selectors.stickyBarAddOnsPriceSelector)
		this.$stickyBarAddOnsTotalSelector = this.addOnComponent.find(this.selectors.stickyBarAddOnsTotalSelector)

		this.states.currentProductPrice = parseInt(this.$stickyBarCurrentPrice.val())

		this.$quantitySelector.on(
			"mfr:quantity-changed",
			this.ProductStickyCounter.bind(this)
		)

		this.addOnComponent.on(
			"mfr:addons-quantity-changed",
			this.ProductStickyCounter.bind(this)
		)

		this.$stickyBarForm.on("submit", this.ProductStickyFormSubmit.bind(this))

		if ( !gsap || !ScrollTrigger || !ScrollTrigger.create ) return

		this.$firstSection = $( this.selectors.firstSection )

		this.initScrollTrigger();
		this.initQuantitySelectorState();
		this.initCustomQuantityState();
	}

	initScrollTrigger() {
		ScrollTrigger.create({
			trigger: this.$firstSection,
			start: "0% top",
			endTrigger: "html",
			end: "bottom top",
			onToggle: self => {
				this.$element.toggleClass( "is-active", self.isActive )
			}
		})
	}

	initQuantitySelectorState() {
		if(window.showQuantitySelector === "false") {
			this.$quantitySelector.addClass("visually-hidden");
		}
	}

	initCustomQuantityState() {
		if(!this.$customQuantitySelector.length > 0) return;
		// this.$quantitySelector.attr("disabled", true);
		this.$customQuantitySelector.on("click", this.__handleCustomQuantityChange.bind(this));
	}

	__handleCustomQuantityChange(e, data) {
		const element = $(e.target).hasClass(".custom-quantity-selector")
		? e.target : $(e.target).closest(this.selectors.customQuantitySelector);
		const selected = $(`${this.selectors.customQuantitySelector}.is-selected`);
		const quantity = $(element).data("quantity");
		const price = $(element).data("price");

		this.$stickyBarCurrentPrice.val(price);
		this.states.currentProductPrice = parseFloat(this.$stickyBarCurrentPrice.val())
		this.$quantitySelector.find('.quantity-selector__input').val(quantity);
		this.$quantitySelectorContainer.text(quantity);
		this.$quantitySelector.trigger("mfr:quantity-changed");

		if (Alpine.store('productStickyBar').addOnsArray.length <= 0) {
			Alpine.store('productStickyBar').runningTotal = this.states.currentProductPrice * quantity
		} else {
			Alpine.store('productStickyBar').currentPrice = this.states.currentTotalPrice
		}

		$(selected).removeClass("is-selected");
		$(element).addClass("is-selected");
	}

	ProductStickyFormSubmit() {
		if (Alpine.store('productStickyBar').addOnsArray.length <= 0) return
		CartJS.addItems([...Alpine.store('productStickyBar').addOnsArray])

		// After adding add-ons to cart, clear the add-ons array, items counter, set running total to selected product price and reset data selection states
		Alpine.store('productStickyBar').addOnsArray = []
		Alpine.store('productStickyBar').addonCounter = 0
		Alpine.store('productStickyBar').runningTotal = Alpine.store('productStickyBar').currentPrice
		Alpine.store('productStickyBar').dataReset = true
	}

	ProductStickyCounter() {
		this.states.currentProductQty = parseInt(this.$quantitySelector.find('.quantity-selector__input').val())
		this.states.currentAddOnsProductQty = parseInt(this.$addOnsQuantitySelector.val())

		if ( this.states.currentAddOnsProductQty > 0 && this.states.currentProductQty == 1 ) {
			this.states.currentTotalPrice = parseInt(this.$addOnsPriceSelector.val())
		} else if (this.states.currentAddOnsProductQty > 0 && this.states.currentProductQty >= 1) {
			const currenItemTotal = this.states.currentProductPrice * this.states.currentProductQty;
			this.states.currentTotalPrice = parseInt(this.$stickyBarAddOnsTotalSelector.val()) + currenItemTotal
		} else {
			this.states.currentTotalPrice = this.states.currentProductPrice * this.states.currentProductQty
		}

		Alpine.store('productStickyBar').currentPrice = this.states.currentTotalPrice
		Alpine.store('productStickyBar').runningTotal = Alpine.store('productStickyBar').addOnsTotalPrice + this.states.currentTotalPrice
	}
}